import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { redFlagResolutionService } from '../services/redFlagResolutionService';

export const generateResolutionForm = createAsyncThunk(
  'redFlagResolution/generateResolutionForm',
  async (redFlagId, { rejectWithValue }) => {
    try {
      const response = await redFlagResolutionService.generateResolutionForm(redFlagId);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getResolutionForm = createAsyncThunk(
  'redFlagResolution/getResolutionForm',
  async (formId, { rejectWithValue }) => {
    try {
      const response = await redFlagResolutionService.getResolutionForm(formId);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const redFlagResolutionSlice = createSlice({
  name: 'redFlagResolution',
  initialState: {
    form: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateResolutionForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateResolutionForm.fulfilled, (state, action) => {
        state.loading = false;
        state.form = action.payload;
      })
      .addCase(generateResolutionForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getResolutionForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getResolutionForm.fulfilled, (state, action) => {
        state.loading = false;
        state.form = action.payload;
      })
      .addCase(getResolutionForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = redFlagResolutionSlice.actions;

export default redFlagResolutionSlice.reducer;
